import { useState } from "react";
import Footer from "../components/Footer/Footer";
import { useMutation } from "convex/react";
import InstagramIcon from "../images/logo/instagram.png";
import WhatsAppIcon from "../images/logo/whatsapp.png";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    interest: "Select Class",
    comment: "",
    address: ""
  });
  const [submitting, setSubmitting] = useState(false);
  const addLead = useMutation("leads:add");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.name === "" || formData.email === "") {
        alert("Please fill required fields (Name and Email).");
        return;
    }
    setSubmitting(true);
    try {
      await addLead({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        interest: formData.interest,
        comment: formData.comment,
        sourceTag: "Website"
      });
      alert("Enquiry submitted successfully!");
      setFormData({ name: "", email: "", phone: "", interest: "Select Class", comment: "", address: "" });
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Failed to submit. Try again.");
    }
    setSubmitting(false);
  };
  return (
    <>
      <section>
        <div className="login-banner relative justify-center flex">
          <h1 className="text-white absolute bottom-[25px] text-[3rem] font-bold">
            Contact Us
          </h1>
        </div>
        {/* contact */}
        <div className="bg-white py-[12rem] page-padding grid grid-cols-2 container gap-10 items-center md1000:grid-cols-1 ">
          {/* first col */}
          <div className="md1000:w-[60%] md1000:flex md1000:flex-col md1000:mx-auto min800:w-[90%] min620:w-full">
            <h2 className="text-black text-[36px] font-bold leading-[1.2]">
              We are here for help you! To Shape Your Body.
            </h2>
            <p className="text-[16px] w-[95%] text-[#646464] font-medium my-[40px]">
              At AK Fitness, we are dedicated to helping you achieve the body of
              your dreams. Our expert trainers and nutritionists will work with
              you to create a personalized fitness and nutrition plan that helps
              you reach your specific goals.
            </p>
            <div className="grid grid-cols-2 grid-rows-2 gap-y-20 min620:grid-cols-1 min620:mx-auto">
              <div className="flex flex-col relative">
                <h3 className="text-[2rem] font-bold mb-10">
                  AK Fitness Jabalpur
                </h3>
                <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
                <p className="text-[15px] font-medium text-[#646464]">
                  Atulyam Towers, Tilwara Road Near Sagda Chowk,
                  <br /> Jabalpur, 482003
                </p>
              </div>
              {/*  */}
              <div className="flex flex-col relative">
                <h3 className="text-[2rem] font-bold mb-10">Opening Hours</h3>
                <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
                <div className="text-[15px] font-medium text-[#646464]">
                  <p>Mon to Sat: 06:00 AM — 10:00 PM</p>
                  <p>Sunday: 08:00 AM — 12:00 PM</p>
                </div>
              </div>
              {/*  */}
              <div className="flex flex-col relative">
                <h3 className="text-[2rem] font-bold mb-10">Information</h3>
                <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
                <div className="text-[15px] font-medium text-[#646464]">
                  <p>+91 94067 61177</p>
                  <p>&nbsp; akfitnessjbp@gmail.com</p>
                </div>
              </div>
              {/*  */}
              <div className="flex flex-col relative">
                <h3 className="text-[2rem] font-bold mb-10">Follow Us On</h3>
                <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[33px]"></span>
                <div className="text-[18px] font-medium text-black flex gap-5">
                  <a
                    href="https://www.instagram.com/akfitnessjbp/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={InstagramIcon}
                      alt="instagram"
                      className="w-[4rem] h-[4rem] object-contain p-[5px] bg-[#f4f4f4] rounded-full cursor-pointer hover:bg-[#ff0336] ease-in duration-200"
                    />
                  </a>
                  <a
                    href="https://wa.me/919406761177"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={WhatsAppIcon}
                      alt="whatsapp"
                      className="w-[4rem] h-[4rem] object-contain p-[5px] bg-[#f4f4f4] rounded-full cursor-pointer hover:bg-[#ff0336] ease-in duration-200"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* second col ---*/}
          <form onSubmit={handleSubmit} className="flex flex-col pt-[30px] pr-[50px] pb-[50px] pl-[45px] bg-[#f8f8f8] relative md1000:w-[65%] md1000:flex md1000:flex-col md1000:mx-auto md1000:mt-14 min800:w-[90%] min620:w-full">
            <h3 className="text-[28px] font-bold mb-14">Leave Us Your Info</h3>
            <span className="bg-[#ff0336] w-[50px] h-[4px] absolute top-[77px]"></span>
             <input
              className="w-full py-[12px] px-[20px] h-[51px] text-[14px] border border-solid border-[#e4e4e4] outline-none mb-8"
              placeholder="Full Name *"
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
            ></input>
            <input
              className="w-full py-[12px] px-[20px] h-[51px] text-[14px] border border-solid border-[#e4e4e4] outline-none mb-8"
              placeholder="Phone Number"
              type="tel"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
            ></input>
            <input
              className="w-full py-[12px] px-[20px] h-[51px] text-[14px] border border-solid border-[#e4e4e4] outline-none mb-8"
              placeholder="Email Address *"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            ></input>
            <input
              className="w-full py-[12px] px-[20px] h-[51px] text-[14px] border border-solid border-[#e4e4e4] outline-none mb-8"
              placeholder="Address"
              type="text"
              value={formData.address}
              onChange={(e) => setFormData({...formData, address: e.target.value})}
            ></input>
            <select 
              className="w-full py-[12px] px-[20px] h-[51px] text-[14px] border border-solid border-[#e4e4e4] outline-none mb-8"
              value={formData.interest}
              onChange={(e) => setFormData({...formData, interest: e.target.value})}
              >
              <option>Select Class</option>
              <option>Body Building</option>
              <option>Boxing</option>
              <option>Running</option>
              <option>Fitness</option>
              <option>Yoga</option>
              <option>Workout</option>
              <option>Kick boxing</option>
              <option>Meditation</option>
              <option>Cycling</option>
            </select>
            <textarea
              placeholder="Comment"
              value={formData.comment}
              onChange={(e) => setFormData({...formData, comment: e.target.value})}
              className="w-full py-[12px] px-[20px] h-[140px] text-[14px] border border-solid border-[#e4e4e4] outline-none mb-8"
            ></textarea>
            <button
              type="submit"
              disabled={submitting}
              className="text-white bg-[#ff0336] w-fit py-[15px] px-[30px] font-bold text-[14px] uppercase self-center mt-6 hover:bg-black transition-colors disabled:bg-gray-400"
            >
              {submitting ? "Submitting..." : "submit now"}
            </button>
          </form>
        </div>

        {/* map */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3669.754779693155!2d79.89749551139462!3d23.106068213197626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981b1d1fa4cc1f1%3A0xe67f5b11802aae3!2sAtulyam%20Towers!5e0!3m2!1sen!2sin!4v1714578000000!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          samesite="Strict"
          title="map"
          style={{ width: "100%", height: "45rem", border: "0px" }}
        ></iframe>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
